var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"用户管理"}},[_vm._v("用户管理")]),_c('el-tab-pane',{attrs:{"label":"配置管理"}},[_vm._v("配置管理")]),_c('el-tab-pane',{attrs:{"label":"角色管理"}},[_vm._v("角色管理")]),_c('el-tab-pane',{attrs:{"label":"定时任务补偿"}},[_vm._v("定时任务补偿")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }